/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useEffect } from 'react';
import { IUtilitySummaryProps } from '../../../shared/UtilityBillBreakdown/SummaryTable/SummaryTable';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { isObjectOrArrayAndEmpty } from '../../../shared/Utils/Utils';
import ConnectionError from '../../../shared/ErrorComponents/ConnectionError';
import withLoadingStatus from '../../../shared/StatusWrappers/LoadingStatus';
import withErrorStatus from '../../../shared/StatusWrappers/ErrorStatus';
import {
  IDetailComponentProps,
  IUtilityBillBreakdownAPIResponse
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { getUtilityTitle } from '../UtilityBillViewDetailsUtils';
import {
  createDynamicColummsFromExisting,
  processRowData,
  skipIfAllZero,
  eliminateNoValueDynamicColumns
} from '../../../shared/UtilityBillBreakdown/UtilityBreakdownUtils';
import SummaryTablePerformance from '../../../shared/UtilityBillBreakdown/SummaryTable/SummaryTablePerformance';

interface IUtilitySummaryTable extends IUtilitySummaryProps {
  onRefresh?: () => Promise<void>;
  isMonthly?: boolean;
  tableLoader?: boolean;
}

const UtilitySummaryTableContent = (props: IUtilitySummaryTable) => {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const {
    rowData,
    columnDetails,
    fileName,
    onRefresh,
    costCurrency,
    isMonthly,
    tableLoader
  } = props;
  if (isObjectOrArrayAndEmpty(rowData)) {
    return (
      <div className="errorDisplay">
        <ConnectionError
          title={t(d.CONNECTIONERRORTITLE)}
          message={t(d.CONNECTIONERROR)}
          onRefresh={onRefresh}
        />
      </div>
    );
  }
  return (
    <div className="utility-bill-summary-component-wrapper">
      <SummaryTablePerformance
        fileName={fileName}
        rowData={rowData}
        columnDetails={columnDetails}
        costCurrency={costCurrency}
        utilityType={props.utilityType}
        isMonthly={isMonthly}
        tableLoader={tableLoader}
      />
    </div>
  );
};

const SummaryTableWithLoader = withLoadingStatus(
  withErrorStatus(UtilitySummaryTableContent)
);

interface IUtilityBillBreakdownExtended {
  data: IUtilityBillBreakdownAPIResponse;
}

const UtilitySummaryWidgetPerformance = (props: IDetailComponentProps) => {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const {
    dataConnector,
    emaasContext,
    utilityType,
    isMonthly,
    tableLoader
  } = props;
  console.log(props, 'emaasContext');
  const [costCurrency, setCostCurrency] = useState<string>('');

  const onRefresh = () =>
    dataConnector && dataConnector.actions && dataConnector.actions.getAll();
  const { all, loading, error, status } = {
    all: [],
    loading: false,
    error: { name: '', message: '', rawResponse: '', status: 200, data: '' },
    status: 200
  };
  const utilityBillBreakdownData = (all as unknown) as IUtilityBillBreakdownExtended;
  const isDataAvailable = utilityBillBreakdownData ? true : false;

  const [isLoading, setIsLoading] = useState<boolean>(loading);
  const [statusCode, setStatusCode] = useState<number | null>(0);
  const [errorInfo, setErrorInfo] = useState(error);
  const [tableData, setTableData] = useState({} as any);
  const [csvFileName, setCsvFileName] = useState('');

  // const accnNUmber = [5200055670,5200055654,5200055644,5200055658,5200055666,5200055652];
  const processData = (data: any, tableData: any) => {
    if (data?.data?.summaryTableData) {
      let tempTableData = JSON.parse(JSON.stringify(tableData));
      const fileName = `${getUtilityTitle(data?.data?.utilityType)}_${
        data?.data?.aggregationsStartDate
      }_${data?.data?.aggregationsEndDate}`;
      setCsvFileName(fileName);
      data.data.summaryTableData.data = skipIfAllZero(
        processRowData(
          data.data.summaryTableData.data,
          utilityType ? utilityType : 'Electricity'
        )
      );
      data.data.summaryTableData.dynamicColumns = eliminateNoValueDynamicColumns(
        data?.data?.summaryTableData.data,
        data.data.summaryTableData.dynamicColumns
      );
      if (
        tempTableData?.data?.summaryTableData?.data &&
        tempTableData?.data?.summaryTableData?.data !== null &&
        tempTableData?.data?.summaryTableData?.data?.length > 0
      ) {
        tempTableData.data.summaryTableData.data = tempTableData.data.summaryTableData.data.concat(
          data.data.summaryTableData.data
        );
      } else {
        tempTableData = data;
      }
      setTableData(tempTableData);
      setCostCurrency(data?.data.utilityCostCurrency);
      // const data: any = await getData(v);
      // debugger;
    }
  };
  useEffect(() => {
    processData(props.tableDataAsync, tableData);
  }, [props.tableDataAsync]);

  // useEffect(() => {
  //   setIsLoading(loading);
  //   if ((isDataAvailable || error || status) && !loading) {
  //     if (isDataAvailable) {
  //       // const fileName = `${getUtilityTitle(
  //       //   utilityBillBreakdownData?.data?.utilityType
  //       // )}_${utilityBillBreakdownData?.data?.aggregationsStartDate}_${
  //       //   utilityBillBreakdownData?.data?.aggregationsEndDate
  //       // }`;
  //       // setCsvFileName(fileName);

  //       if (utilityBillBreakdownData?.data?.summaryTableData.data) {
  //         // utilityBillBreakdownData.data.summaryTableData.data =
  //         // skipIfAllZero(
  //         //   processRowData(
  //         //     utilityBillBreakdownData?.data?.summaryTableData.data,
  //         //     utilityType ? utilityType : 'Electricity'
  //         //   )
  //         // );
  //         // processData(accnNUmber)
  //         // utilityBillBreakdownData.data.summaryTableData.dynamicColumns = eliminateNoValueDynamicColumns(
  //         //   utilityBillBreakdownData?.data?.summaryTableData.data,
  //         //   utilityBillBreakdownData.data.summaryTableData.dynamicColumns
  //         // );
  //         // setTableData(utilityBillBreakdownData);
  //         // setCostCurrency(utilityBillBreakdownData?.data.utilityCostCurrency);
  //       }
  //     }
  //     setErrorInfo(error);
  //     setStatusCode(status);
  //   }
  // }, [isDataAvailable, loading, status]);

  console.log(tableData?.data?.summaryTableData?.data, 'tableData');
  console.log(tableData, 'tableData2');
  return (
    <>
      {tableData?.data?.summaryTableData?.data &&
        tableData?.data?.summaryTableData?.data !== null && (
          <UtilitySummaryTableContent
            // loading={false}
            // error={{name: '', message: '', rawResponse: '', data:''}}
            // statusCode={200}
            // onRefresh={onRefresh}
            rowData={tableData?.data?.summaryTableData?.data}
            columnDetails={tableData?.data?.summaryTableData?.dynamicColumns}
            fileName={csvFileName}
            // loadingText={t(d.LOADING)}
            // title={t(d.CONNECTIONERRORTITLE)}
            // noDataMessage={t(d.NODATAAVAILABLE)}
            // connectionErrorMessage={t(d.CONNECTIONERROR)}
            costCurrency={costCurrency}
            utilityType={props.utilityType ?? ''}
            isMonthly={isMonthly}
            tableLoader={tableLoader}
          />
        )}
    </>
  );
};
export default UtilitySummaryWidgetPerformance;
